<template>
    <router-view />
    <v-layout class="rounded rounded-md">
    <!-- アプリバー -->
    <TopBar @toggle-drawer="drawer = !drawer" />
    <!-- メニュー -->
    <TopMenu v-model="drawer" />

      <!-- メイン -->
      <v-main class="align-center justify-center" style="min-height: 300px;">
        <SportsStoreEditor/>
      </v-main>
  
      <!-- フッター -->
      <v-footer app color="primary">
      </v-footer>
    </v-layout>
  </template>
  
  <script>
  import TopBar from '@/components/TopBar.vue'
  import TopMenu from '@/components/TopMenu.vue'
  import SportsStoreEditor from '@/components/SportsStoreEditor.vue'
  
  export default {
    name: 'App',
    components: {
        TopBar,
        TopMenu,
        SportsStoreEditor,
    },
    data: () => ({
      drawer: false,
    }),
  }
  </script>
  